






import Vue from 'vue';

import HostedPaymentCreateOrEdit from './HostedPaymentCreateOrEdit.vue';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: 'Edit Hosted Payment' as string,
    };
  },
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  methods: {
  },
  components: {
    HostedPaymentCreateOrEdit,
  },
});
